module.exports = __webpack_public_path__ + "img/五指毛桃.ffcd4f57.jpg";